import { Auditable, QueryParams, SortParams, Territory } from "..";

export interface Office extends Auditable {
    name: string;
    tenantId: number;
    territoryId?: number;
    isMainOffice: boolean;
    address1?: string;
    address2?: string;
    city?: string;
    state?: string;
    zip?: string;
    phone?: string;
    fax?: string;
    email?: string;

    territory?: Territory;
}

export const DefaultOfficeQueryParams: QueryParams = {
    name: "",
};

export const DefaultOfficeSortParams: SortParams = {
    orderBy: "name",
    orderDesc: "false",
};
